<template>
  <div class="md:p-[20px] bg-[#F7F8F7] h-auto">
    <Nav-Bar />
    <nuxt />
    <Side-Bar />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import SideBar from './components/SideBar.vue'


export default {
  name: 'App',
  components: {
    NavBar,
    SideBar

  }
}
</script>

